import {DadProductPrice} from './dadProductPrice';

export class DadProduct {
  id: number;
  productCode: string;
  startDate: string;
  productType: string;
  internalProductCode: string;
  rebillingProductType: string;
  rebillingColor: string;
  dadProductPrices: DadProductPrice[];

  constructor(productCode: string, productType: string, internalProductCode: string, rebillingProductType: string,
              rebillingColor: string, startDate: any, id: number, dadProductPrices: DadProductPrice[]) {
    this.productCode = productCode;
    this.productType = productType;
    this.internalProductCode = internalProductCode;
    this.rebillingProductType = rebillingProductType;
    this.rebillingColor = rebillingColor;
    this.startDate = startDate;
    this.id = id;
    this.dadProductPrices = dadProductPrices;
  }
}
